import React, { useRef, useLayoutEffect, useEffect } from "react";

const SlidingRadioTabs = ({
    name,
    options = [],              // [{ value:'all', label:'전체' }, ...]
    value,                      // 현재 선택값
    onChange,                   // (v) => void
    className = "",
    visible = true,             // 패널/탭이 보이는지(처음 열릴 때 무애니메이션 정렬용)
}) => {
    const groupRef = useRef(null);
    const tabRefs = useRef({}); // { [value]: spanElement }

    const setIndicator = (animate = true) => {
        const group = groupRef.current;
        const el = tabRefs.current[value];
        if (!group || !el) return;

        // 필요시 애니메이션 임시 차단
        if (!animate) {
            group.classList.add("no-anim");
        }

        const gr = group.getBoundingClientRect();
        const er = el.getBoundingClientRect();
        const pad = parseFloat(getComputedStyle(group).paddingLeft) || 0;

        group.style.setProperty("--ind-x", `${er.left - gr.left - pad}px`);
        group.style.setProperty("--ind-w", `${er.width}px`);

        if (!animate) {
            // reflow로 'transition: none' 적용을 확정한 뒤 다시 켬
            void group.offsetWidth;
            group.classList.remove("no-anim");
        }
    };

    // 1) 최초 1회: 무애니메이션 고정(첫 진입 시 튀는 슬라이드 방지)
    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            setIndicator(false);
            // 웹폰트 로드로 폭 변동 가능성 → 한 번 더 무애니메이션 정렬
            if (document.fonts?.ready) {
                document.fonts.ready.then(() => setIndicator(false)).catch(() => {});
            }
        });
    }, []);

    // 2) 탭 값 바뀔 때만 애니메이션 적용
    useEffect(() => {
        setIndicator(true);
    }, [value]);

    // 3) 리사이즈 시에는 보통 애니메이션 없이 재정렬이 자연스러움
    useEffect(() => {
        const onResize = () => setIndicator(false);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // 4) 패널/탭이 숨겼다가 다시 보일 때도 무애니메이션 고정
    useEffect(() => {
        if (visible) setIndicator(false);
    }, [visible]);

    return (
        <div className={`modeGroup ${className}`} ref={groupRef}>
            <span className="indicator" aria-hidden="true" />
            {options.map((opt) => (
                <label key={opt.value} className="mode">
                    <input
                        type="radio"
                        name={name}
                        value={opt.value}
                        checked={value === opt.value}
                        onChange={() => onChange(opt.value)}
                    />
                    <span ref={(el) => (tabRefs.current[opt.value] = el)}>
                        {opt.label}
                    </span>
                </label>
            ))}
        </div>
    );
};

export default SlidingRadioTabs;
